import { RootState } from "../../store";

export const selectQuiz = (state: RootState) => state.quiz;